import { ArrowUpRight, Star } from '@phosphor-icons/react';
import { customerReviews, googleProfileUrl } from '../content/reviews';
import { Reveal } from './Reveal';

export function CustomerReviews() {
  return (
    <section className="customer-reviews section-pad section-shell" aria-labelledby="customer-reviews-title">
      <Reveal className="section-heading">
        <p className="section-kicker">In our customers’ words</p>
        <h2 id="customer-reviews-title">Selected customer reviews.</h2>
        <p>Selected excerpts from customer reviews on Google. Read the original reviews to hear more about their experience.</p>
      </Reveal>
      <div className="customer-reviews__grid">
        {customerReviews.map((review, index) => (
          <Reveal as="figure" className="customer-review" key={review.author} delay={index * 0.06}>
            <div className="customer-review__stars" role="img" aria-label={`${review.rating} out of 5 stars`}>
              {Array.from({ length: review.rating }, (_, star) => <Star key={star} size={18} weight="fill" aria-hidden="true" />)}
            </div>
            <blockquote cite={review.url}><p>“{review.excerpt}”</p></blockquote>
            <figcaption>
              <strong>{review.author}</strong>
              <a className="text-link" href={review.url} aria-label={`Read ${review.author}’s review on Google`}>
                Google review excerpt <ArrowUpRight aria-hidden="true" size={16} />
              </a>
            </figcaption>
          </Reveal>
        ))}
      </div>
      <a className="text-link customer-reviews__all" href={googleProfileUrl}>
        Read all reviews on Google <ArrowUpRight aria-hidden="true" size={17} />
      </a>
    </section>
  );
}
